// type='' for shapefile zips, KML, and KMZ, so we can't rely on it. The signed PUT URL is minted
// for a specific content_type, and a GCS V4 signature INCLUDES that content-type — so the PUT
// header MUST equal what was a dropped.
const BY_EXT: Record<string, string> = {
  geojson: "application/geo+json",
  json: "application/geo+json",
  zip: "application/zip",
  kml: "application/vnd.google-earth.kml+xml",
  kmz: "application/vnd.google-earth.kmz",
  csv: "text/csv",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
};

export function extensionOf(name: string): string {
  const m = /\.([^.]+)$/.exec(name.toLowerCase());
  return m ? m[1] : "";
}

export function contentTypeOf(file: File): string {
  return (
    BY_EXT[extensionOf(file.name)] || file.type || "application/octet-stream"
  );
}

// Boundary file formats we accept via drag-drop / browse (async parses these).
export const BOUNDARY_EXTS = ["geojson", "json", "zip", "kml", "kmz"] as const;
export const BOUNDARY_ACCEPT = ".geojson,.json,.zip,.kml,.kmz";

export function isSupportedBoundaryFile(name: string): boolean {
  return (BOUNDARY_EXTS as readonly string[]).includes(extensionOf(name));
}

export function fmtBytes(n: number): string {
  if (!Number.isFinite(n) || n < 0) return "";
  if (n < 1024) return `${n} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let v = n / 1024;
  let u = 0;
  while (v >= 1024 && u < units.length - 1) {
    v /= 1024;
    u++;
  }
  return `${v >= 10 ? Math.round(v) : Math.round(v * 10) / 10} ${units[u]}`;
}
